// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";
import MilitarySelectOfficerLayer from "./MilitarySelectOfficerLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitarySelectOfficerItem extends BaseComponent {

    @property({ type: cc.Label, displayName:'' })
	labelEarningAdd: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelEarning: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGassisonAdd: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGarrison: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelExclusiveCity: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

  
	private officerId: string = null;
	private cityId: string = null;
	private csvInfo: any = null;
    private _parent: MilitarySelectOfficerLayer = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
		this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.OFFICER, this.officerId);
		if (!this.csvInfo) {
			console.error('未找到武将数据 officerId = ', this.officerId);
		}
		this.initUI();
    }

	setData(
        officerId: string
        , cityId: string
        , _parent: MilitarySelectOfficerLayer
    ) {
        this.officerId = officerId;
        this.cityId = cityId;
        this._parent = _parent;
    }

	initUI() {
		this.labelName.string = this.csvInfo.name;

		this.refreshEarning();
		this.refreshGassison();
		this.refreshHead();
		this.refreshExclusiveCity();
	}

	refreshEarning() {
		let eraning_promote = Number(this.csvInfo.eraning_promote);
		let exclusive_eraning_promote = Number(this.csvInfo.exclusive_eraning_promote);
		this.labelEarning.string = Math.floor(eraning_promote * 100) + '%';
		this.labelEarningAdd.string = ' +' + Math.floor((exclusive_eraning_promote - eraning_promote) * 100) + '%';
	}

	refreshGassison() {
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
        let data = militaryOfficerData.lists.get(this.officerId);
        
		let normalGassison = Number(this.csvInfo.garrison);
		let exclusive_garrison = Number(this.csvInfo.exclusive_garrison);
        let eAdd = Math.floor((exclusive_garrison - normalGassison) * 100);
        normalGassison += data.addGarrison;

        let gv = (normalGassison * 100).toFixed(1);
		this.labelGarrison.string = gv + '%';
		this.labelGassisonAdd.string = ' +' + eAdd + '%';
	}

	refreshExclusiveCity() {
		let exclusive_city = this.csvInfo.exclusive_city;
		let cityCsv = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, exclusive_city);
		if (!cityCsv) {
			this.labelExclusiveCity.string = '';
			console.error('未找到城池数据 exclusive_city = ', exclusive_city);
			return;
		}

		this.labelExclusiveCity.string = cityCsv.name;
	}

	refreshHead() {
		this.sprHead.node.active = false;
        if (utilsModel.isValidNumberValue(this.csvInfo.icon)) {
            let iconPath = "res/recruit/head/" + this.csvInfo.icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.militaryBundle).load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.sprHead.node.active = true;
                        this.sprHead.spriteFrame = imgs;
                    }
                }
            );
        }
	}

	onClickArrange() {
		O1HD.getManagers().soundMgr.playSound("anNiu").then();

		let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
		let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
		let militaryCityData = militaryCityDataManage.militaryCityData;

        let data = militaryOfficerData.lists.get(this.officerId);
        data.curGarrisonCity = this.cityId;

		let cityData = militaryCityData.lists.get(this.cityId);
		cityData.officerId = this.officerId;

		militaryOfficerData.saveLocalData();
		militaryCityData.saveLocalData();
		this._parent.onSelectOfficer();
	}
}
